module.exports = __webpack_public_path__ + "img/page.888fc850.png";